import { render, staticRenderFns } from "./InvoiceMail.vue?vue&type=template&id=a6255df0&scoped=true"
import script from "./InvoiceMail.vue?vue&type=script&lang=js"
export * from "./InvoiceMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6255df0",
  null
  
)

export default component.exports